/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auditor_Validation_TestsInputs */

const en_auditor_validation_tests = /** @type {(inputs: Auditor_Validation_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation Tests`)
};

const nl_auditor_validation_tests = /** @type {(inputs: Auditor_Validation_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatietests`)
};

/**
* | output |
* | --- |
* | "Validation Tests" |
*
* @param {Auditor_Validation_TestsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const auditor_validation_tests = /** @type {((inputs?: Auditor_Validation_TestsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auditor_Validation_TestsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_auditor_validation_tests(inputs)
	return en_auditor_validation_tests(inputs)
});